var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"uc-switch",class:{ checked: _vm.value },attrs:{"role":"switch","aria-checked":_vm.value ? 'true' : 'false'},on:{"click":() => _vm.onChange(_vm.value)}},_vm.$listeners),[_c('span',{staticClass:"slider"}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.value ? 'On' : 'Off'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }